import styled from 'styled-components'
import { getFontStyle } from '@diversioteam/diversio-ds'

import { Title } from './../FormBuilder/Fields/fieldsInactive.styles'

export const PreviewWrapper = styled.section`
    width: 100%;
    max-width: 800px;
    min-width: 520px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .dds-toast {
        border-radius: 15px;
    }
`

export const SurveyTitle = styled(Title)`
    ${getFontStyle('h2Bold')}
`

export const Description = styled.p`
    color: ${({ theme }) => theme.colors.secondary500};
    white-space: pre-wrap;

    ${getFontStyle('p02Regular')}
`

export const Footer = styled.footer`
    padding-top: 16px;
    border-top: 1px solid ${({ theme }) => theme.colors.secondary100Transparent};
`

export { FieldInactiveWrapper, Header, Required, TextField, Title } from './../FormBuilder/Fields/fieldsInactive.styles'
